<template>
  <div class="tscrubber-container">
    <div class="tscrubber-timeline">
      <div class="tscrubber-timeline-end"></div>
      <div class="tscrubber-timeline-end--right"></div>
    </div>
    <div
      v-bind:style="{ left: handlePos + '%' }"
      v-on:mousedown="mouseDown"
      class="tscrubber-handle-container"
      ref="handleBody"
    >
      <div
        class="tscrubber-main-body"
        v-bind:style="{ width: handleWidth + 'px' }"
      >
        <div
          v-on:mousedown="handleMouseDown('right')"
          class="tscrubber-handle-handle tscrubber-handle-handle--right"
        ></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import moment from "moment";
export default {
  name: "bg-scrubber",
  props: ["videoRef", "currentTime", "scrubberTimeChange"],
  data() {
    return {
      isMouseDown: false,
      isHandleMouseDown: false,
      handlePos: ".5",
      handleWidth: 120,
      currentFormattedTime: this.convertToMmSs(this.currentTime),
      width: this.videoRef.clientWidth,
      duration: "",
      start: 0,
      end: 5,
      handleLocation: 0,
    };
  },
  created() {
    this.videoRef.addEventListener("loadedmetadata", (e) => {
      this.duration = moment(0)
        .add(this.videoRef.duration, "seconds")
        .format("mm:ss");
    });
  },
  methods: {
    handleMouseDown(event) {
      this.isHandleMouseDown = true;
      document.body.style.cursor = "grabbing";

      document.addEventListener("mousemove", this.handleGripMouseDownMove);
      document.addEventListener("mouseup", this.handleGripMouseUp);
    },
    handleGripMouseDownMove(event) {
      if (this.isHandleMouseDown) {
        event.preventDefault();

        const position = (this.handlePos / 100) * this.width;

        const clickX =
          event.clientX - 314 - this.$refs.handleBody.clientWidth - position;
        const newSize = this.handleWidth + clickX;
        this.handleWidth = this.handleDragBounds(newSize);
        if (newSize / this.width < 0.02) {
          return;
        }
        this.$emit("handleSizeChange", newSize / this.width);
      }
    },
    mouseDown(event) {
      // enable scrubbing
      this.isMouseDown = true;
      document.body.style.cursor = "grabbing";

      document.addEventListener("mousemove", this.handleMouseMove);
      document.addEventListener("mouseup", this.handleMouseUp);
    },
    handleMouseMove(event) {
      if (this.isMouseDown && !this.isHandleMouseDown) {
        event.preventDefault();
        var newPercentage = ((event.clientX - 314) / this.width) * 100;

        const max =
          100 - ((this.$refs.handleBody.clientWidth + 3) / this.width) * 100;

        const min = (3 / this.width) * 100;
        const handleWidthInPercentage =
          ((this.$refs.handleBody.clientWidth / this.width) * 100) / 2;
        const newPos = this.handleBounds(
          newPercentage - handleWidthInPercentage,
          max,
          min
        );
        this.$emit(
          "handleMovement",
          newPos,
          (this.$refs.handleBody.clientWidth / this.width) * 100
        );
        this.handlePos = newPos;
      }
    },
    handleBounds(time, max, min) {
      if (time > max) {
        return max;
      } else if (time <= 0) {
        return min;
      } else {
        return time;
      }
    },
    handleDragBounds(size) {
      const posInPx = (this.handlePos / 100) * this.width;
      if (posInPx + size > this.width) {
        return this.handleWidth;
      } else if (size < 20) {
        return 20;
      } else {
        return size;
      }
    },
    handleMouseUp: function ($event) {
      this.isMouseDown = false;
      document.body.style.cursor = "default";
    },
    handleGripMouseUp: function ($event) {
      this.isHandleMouseDown = false;
      document.body.style.cursor = "default";
    },
    convertToMmSs(newVal) {
      const s = parseInt(newVal % 60);
      const m = parseInt((newVal / 60) % 60);
      const time = moment().seconds(s).minutes(m).format("mm:ss");
      return time;
    },
  },
  watch: {},
};
</script>
